var map = {
	"./assets/case3-1.jpeg": 90076,
	"./assets/en/case3-1.jpeg": 41601,
	"pages/home/assets/case3-1.jpeg": 90076,
	"pages/home/assets/en/case3-1.jpeg": 41601
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 40796;